export default __webpack_public_path__ + "static/media/personal_brand.5da2b11d.svg";